@if (shape?.shape) {
  <icc-dimensions-legend [shape]="shape?.shape" [variant]="shape?.type" highlight="all"></icc-dimensions-legend>
}
<form [formGroup]="dimensionsForm">
  @for (field of fields; track field) {
    @if (showDimensionsRestrictionSlidingDoors && field.name == 'width' && sizeRangeFull['minWidth'] !== -1 && sizeRangeFull['maxWidth'] !== -1) {
      <span
        class="dimension"
        [ngClass]="{'valid': sizeRange.widthFullValid, 'invalid': !sizeRange.widthFullValid}"
        >
        {{'DIMENSION|Pełny zakres rozmiarów' | translate}} {{sizeRangeFull['minWidthMM']}} - {{sizeRangeFull['maxWidthMM']}}
      </span>
    }
    @if (showDimensionsRestrictionSlidingDoors && field.name == 'height'  && sizeRangeFull['minHeight'] !== -1 && sizeRangeFull['maxHeight'] !== -1) {
      <span
        class="dimension"
        [ngClass]="{'valid': sizeRange.heightFullValid, 'invalid': !sizeRange.heightFullValid}"
        >
        {{'DIMENSION|Pełny zakres rozmiarów' | translate}} {{sizeRangeFull['minHeightMM']}} - {{sizeRangeFull['maxHeightMM']}}
      </span>
    }
    @if (field.field && field.type === 'number') {
<mat-form-field [ngClass]="{
      'sliding-door-input': showDimensionsRestrictionSlidingDoors && sizeRange.width != '', 'dimension-input' : showDimensionsRestriction}">
        @if (field.name == 'width') {
          <mat-label [ngClass]="{'input--invalid': showDimensionsRestrictionSlidingDoors && !sizeRange.widthValid}" translate>DIMENSION|Szerokość (S)</mat-label>
        }
        @if (field.name == 'height') {
          <mat-label [ngClass]="{'input--invalid': showDimensionsRestrictionSlidingDoors && !sizeRange.heightValid}" translate>DIMENSION|Wysokość (H)</mat-label>
        }
        @if (field.name == 'h1') {
          <mat-label translate>DIMENSION|H1</mat-label>
        }
        @if (field.name == 'h2') {
          <mat-label translate>DIMENSION|H2</mat-label>
        }
        @if (field.name == 'h3') {
          <mat-label translate>DIMENSION|H3</mat-label>
        }
        @if (field.name == 's1') {
          <mat-label translate>DIMENSION|S1</mat-label>
        }
        @if (field.name == 's2') {
          <mat-label translate>DIMENSION|S2</mat-label>
        }
        @if (field.name == 's3') {
          <mat-label translate>DIMENSION|S3</mat-label>
        }
        @if (field.name == 'diameter') {
          <mat-label translate>DIMENSION|Średnica (S):</mat-label>
        }
        @if (field.name == 'perimeter') {
          <mat-label translate>DIMENSION|Obwód:</mat-label>
        }
        <input
          [ngClass]="{'input--invalid': showDimensionsRestrictionSlidingDoors && ((!sizeRange.widthValid && field.name == 'width') || (!sizeRange.heightValid && field.name == 'height'))}"
          matInput
          iccDimensionInput
          type="number"
          ngModelChange="changeDimensions()"
          [formControlName]="field.field"
          >
          @if (showDimensionsRestriction && field.name == 'width') {
            <mat-hint>{{ 'DIMENSION|Zakres rozmiarów' | translate }} ({{dimensionsRestriction.minWidth}} - {{dimensionsRestriction.maxWidth}})</mat-hint>
          }
          @if (showDimensionsRestriction && field.name == 'height') {
            <mat-hint>{{ 'DIMENSION|Zakres rozmiarów' | translate }} ({{dimensionsRestriction.minHeight}} - {{dimensionsRestriction.maxHeight}})</mat-hint>
          }
          @if (showDimensionsRestrictionSlidingDoors && field.name == 'width') {
            <mat-hint [ngClass]="{'input--invalid': showDimensionsRestrictionSlidingDoors && !sizeRange.widthValid}"> {{sizeRange.width}}</mat-hint>
          }
          @if (showDimensionsRestrictionSlidingDoors && field.name == 'height') {
            <mat-hint [ngClass]="{'input--invalid': showDimensionsRestrictionSlidingDoors && !sizeRange.heightValid}">{{sizeRange.height}}</mat-hint>
          }
          <span matPrefix>
            <icc-dimensions-legend [shape]="shape?.shape" [variant]="shape?.type" [highlight]="field.highlight || field.field" [fieldPrefix]="true"></icc-dimensions-legend>
          </span>
          <span matSuffix>{{ dimensionUnit.unitSymbol }}</span>
        </mat-form-field>
      }
      @if (field.field && field.options.length > 0 && field.type === 'select') {
        <mat-form-field>
          @if (field.name == 'shortening') {
            <mat-label>{{ 'DOOR|Skracanie:' | translate }}</mat-label>
          }
          <mat-select [formControlName]="field.field">
            @for (option of field.options; track option) {
              <mat-option [value]="option">{{ option }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
      @if (field.value) {
        <span>
          <p>{{field.value}}</p>
          <span>{{ dimensionUnit.unitSymbol }}</span>
        </span>
      }
    }
    @if (shape?.shape === 'arc') {
      <mat-radio-group>
        <mat-radio-button value="radialArc">{{'DIMENSION|Łuk promieniowy' | translate}}</mat-radio-button>
        <mat-radio-button value="arcFromTemplate">{{'DIMENSION|Łuk z szablonu' | translate}}</mat-radio-button>
      </mat-radio-group>
    }
  </form>
  @if (isFoundationProfileAvailable()) {
    <form [formGroup]="foundationForm" class='foundation-form'>
      <mat-slide-toggle class='foundation-form__slide' formControlName="isFoundationProfile">
        {{'WINDOW|Podwalina' | translate}}
      </mat-slide-toggle>
      @if (foundationProfiles.length > 1 && foundationForm.controls.isFoundationProfile?.value) {
        <mat-form-field>
          <mat-label>{{'WINDOW|Wybierz profil' | translate}}</mat-label>
          <mat-select formControlName="foundationProfile">
            @for (profile of foundationProfiles; track profile) {
              <mat-option [value]="profile.id">{{ profile.name }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
      @if (foundationForm.controls.isFoundationProfile?.value) {
        <mat-form-field>
          <mat-label translate>WINDOW|Wysokość profilu</mat-label>
          <input matInput iccDimensionInput type="number" formControlName="foundationProfileHeight">
          <span matSuffix>{{ dimensionUnit.unitSymbol }}</span>
        </mat-form-field>
      }
      @if (foundationForm.controls.isFoundationProfile?.value && foundationActualProfile) {
        <p>{{'DIMENSION|Wartość powinna mieścić się w zakresie od {minHeight} do {maxHeight}' | translate : {minHeight: foundationActualProfile.minHeight | unitmm:1, maxHeight: foundationActualProfile.maxHeight | unitmm:1} }}</p>
      }
    </form>
  }
  @if (isRollerShutterAvailable()) {
    <div class='shutter-form'>
      @if (!(hasRoller$ | async)) {
        <button mat-button color="primary"
          (click)="openRollerShutterConfigurator()"
          >
          {{ 'ROLLER_SHUTTER_LEGACY|Dodaj roletę' | translate }}
        </button>
      }
      @if (hasRoller$ | async) {
        <button mat-button color="primary"
          (click)="openRollerShutterConfigurator()"
          >
          {{ 'ROLLER_SHUTTER_LEGACY|Edytuj roletę' | translate }}
        </button>
      }
      @if (hasRoller$ | async) {
        <button mat-button color="primary"
          (click)="removeRollerShutter()"
          >
          {{ 'ROLLER_SHUTTER_LEGACY|Usuń roletę' | translate }}
        </button>
      }
    </div>
  }
